export namespace TempUtil {
	export const getCount = (time: number, coolDown: number) => Math.floor(time / coolDown);
}
